import AndrewJoseph from '../../assets/andrew-joseph.png';
import GeorgeAlan from '../../assets/george-alan.png';
import NancyGrace from '../../assets/nancy-grace.png';
import SusanMarie from '../../assets/susan-marie.png';
import JohnPaul from '../../assets/john-paul.png';

export const sampleUsers = {
  users: [
    {
      uid: 'cometchat-uid-1',
      name: 'Andrew Joseph',
      avatar: AndrewJoseph,
    },
    {
      uid: 'cometchat-uid-2',
      name: 'George Alan',
      avatar: GeorgeAlan,
    },
    {
      uid: 'cometchat-uid-3',
      name: 'Nancy Grace',
      avatar: NancyGrace,
    },
    {
      uid: 'cometchat-uid-4',
      name: 'Susan Marie',
      avatar: SusanMarie,
    },
    {
      uid: 'cometchat-uid-5',
      name: 'John Paul',
      avatar: JohnPaul,
    },
  ],
};
